import { Guid } from '../../../../../utilities/guid';
import KeyDownEvent = JQuery.KeyDownEvent;
import { DataGridColumn, DataType, QueryFilter, SourceType } from "../../../../../models/queries/queries.models";
import { BindingEngine, computedFrom } from "aurelia-binding";
import { StringUtilities } from "../../../../../utilities/strings";
import { Many2ManyFilterItem } from "../../../../components/many-to-many-filter-selector/many-to-many-filter-selector";
import { MobileHelper } from "../../../../../helpers/mobile-helper";
import { I18N } from "aurelia-i18n";
import { VesselCompanyAssociationTypes } from "../../../../../models/companies/company.models";
import { CustomGridPageBase } from "../../../common/custom-grid-page.base";
import { autoinject, transient } from 'aurelia-dependency-injection';
import { RightShipQiRouterConstants } from '../../../../../configuration/rightshipqi-router.constants';
import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { activationStrategy } from 'aurelia-router';

type MultipleFilterListColumn = DataGridColumn & {
    filterActive?: boolean;
};
@autoinject()
@transient()
export class CompanySearch extends CustomGridPageBase{

    public keywords : string

    public getItemRoute = (id) => `/company/${id}}/overview`;
    public mobileSelectedFilter: number[] = [];
    public selectedStatusFilter: number[] = [];
    public keywordProperties: string[];

    public initialFilters: QueryFilter[];
    public filters: MultipleFilterListColumn[];
    public isMobileFilterOpen: boolean = false;
    public selectedFilter: { title: string, clear: () => void, apply: () => void };

    constructor(i18N: I18N, protected bindingEngine: BindingEngine, private cacheClient: CacheClientService) {
        super(i18N, "Company Search", bindingEngine)

        this.columns.push();
        this.initialSorting = this.getSorting();
    }

    public getSorting() {
        let columns: DataGridColumn[] = [];
        columns =  []

        return columns;
    }
    //#region Country Desktop Filter
    public selectedCountries: [] = []
    public showCountryFilter: boolean;
    public toggleCountryFilter() {
        if(!this.showCountryFilter) {
            this.closeAllFilters()
        }
        this.showCountryFilter = !this.showCountryFilter;
    }

    public countrySetSelectedFilter() {
        this.selectedFilter = {
            title: "Country",
            clear: () => {
                this.clearCountryFilter();
            },
            apply: () => {
                this.showCountryFilter = false;
            }
        }
    }

    public clearCountryFilter() {
        this.selectedCountries = [];
        this.setItemSource();
    }

    applyCountryFilter(event, reload: boolean = true) {
        this.selectedCountries = event.map(x => x.id);
        if (reload == true) this.setItemSource();
        this.showCountryFilter = false;
    }

    @computedFrom("selectedCountries")
    public get countryFilterActive() {
        return this.selectedCountries.length > 0
    }
    //#endregion

    //#region Nationality of registration Desktop Filter
    public selectedNors: [] = []
    public showNorFilter: boolean;
    public toggleNorFilter() {
        if(!this.showNorFilter) {
            this.closeAllFilters()
        }
        this.showNorFilter = !this.showNorFilter;
    }

    norSetSelectedFilter() {
        this.selectedFilter = {
            title: "NationalityOfRegistration",
            clear: () => {
                this.clearNorFilter();
            },
            apply: () => {
                this.showNorFilter = false;
            }
        }
    }

    public clearNorFilter() {
        this.selectedNors = [];
        this.setItemSource();
    }

    applyNorFilter(event, reload: boolean = true) {
        this.selectedNors = event.map(x => x.id);
        if (reload == true) this.setItemSource();
        this.showNorFilter = false;
    }

    @computedFrom("selectedNors")
    public get norFilterActive() {
        return this.selectedNors.length > 0
    }
    //#endregion

    //#region Nationality of control Desktop Filter
    public selectedNocs: [] = []
    public showNocFilter: boolean;
    public toggleNocFilter() {
        if(!this.showNocFilter) {
            this.closeAllFilters()
        }
        this.showNocFilter = !this.showNocFilter;
    }

    public nocSetSelectedFilter() {
        this.selectedFilter = {
            title: "NationalityOfControl",
            clear: () => {
                this.clearNocFilter();
            },
            apply: () => {
                this.showNocFilter = false;
            }
        }
    }

    public clearNocFilter() {
        this.selectedNocs = [];
        this.setItemSource();
    }

    applyNocFilter(event, reload: boolean = true) {
        this.selectedNocs = event.map(x => x.id);
        if (reload == true) this.setItemSource();
        this.showNocFilter = false;
    }

    @computedFrom("selectedNocs")
    public get nocFilterActive() {
        return this.selectedNocs.length > 0
    }
    //#endregion

    //#region Vessel under management Desktop Filter

    public vumDefaults : {low: number, high: number} = {low: 0, high:360};
    public vumFirstFilter: number = this.vumDefaults.low;
    public vumSecondFilter: number = this.vumDefaults.high;
    public showVumFilter: boolean;
    public vumIsApplied: boolean
    public toggleVumFilter() {
        if(!this.showVumFilter) {
            this.closeAllFilters()
        }
        this.showVumFilter = !this.showVumFilter;
    }

    public vumSetSelectedFilter() {
        this.selectedFilter = {
            title: "VesselUnderManagement",
            clear: () => {
                this.clearVumFilter();
            },
            apply: () => {
                this.showVumFilter = false;
            }
        }
    
    }

    public clearVumFilter() {
        this.vumFirstFilter = this.vumDefaults.low;
        this.vumSecondFilter = this.vumDefaults.high;
        this.vumIsApplied = false
    }

    public applyVumFilter(filterValue: { low: number, high: number } = null) {
        if (filterValue) {
            this.vumFirstFilter = filterValue.low;
            this.vumSecondFilter = filterValue.high;
            this.vumIsApplied = true;
        }

        this.setItemSource();
        this.showVumFilter = false;
    }

    @computedFrom("vumFirstFilter", "vumSecondFilter")
    public get vumFilterActive() : boolean {
        return this.vumFirstFilter > this.vumDefaults.low || this.vumSecondFilter < this.vumDefaults.high;
    }

    //#endregion

    //#region Role Desktop Filter
    public roles = Object.keys(VesselCompanyAssociationTypes).filter(x => isNaN(Number(x))).map(x => { return new Many2ManyFilterItem(VesselCompanyAssociationTypes[x], x, StringUtilities.camelize('has ' + x.toLowerCase().trim()), DataType.Boolean); })
  
    public selectedRoles: [] = []
    public roleFilters: [] = [];
    public showRoleFilter: boolean;
    public toggleRoleFilter() {
        if(!this.showRoleFilter) {
            this.closeAllFilters()
        }
        this.showRoleFilter = !this.showRoleFilter;
    }
    
    public roleSetSelectedFilter($event) {
        this.selectedFilter = {
            title: "Role",
            clear: () => {
                this.clearRoleFilter();
            },
            apply: () => {
                this.roleFilters = $event.detail.appliedFilters;
                this.setItemSource();
                this.showRoleFilter = false;
            }
        }
    }

    public clearRoleFilter() {
        this.selectedRoles = [];
        this.roleFilters = [];
        this.setItemSource();
    }
  
    applyRoleFilter($event) {
        this.roleFilters = $event.detail.appliedFilters;
        this.showRoleFilter = false;
        this.setItemSource();
    }
  
    @computedFrom("selectedRoles")
    public get roleFilterActive() {
        return this.selectedRoles && this.selectedRoles.length > 0
    }
    //#endregion

    public clearAllFilters() {
        this.clearCountryFilter();
        this.clearNorFilter();
        this.clearNocFilter();
        this.clearVumFilter();
        this.clearRoleFilter();
        
        this.setItemSource();
    }

    public closeAllFilters() {
        this.showCountryFilter = false
        this.showNorFilter = false
        this.showNocFilter = false
        this.showVumFilter = false
        this.showRoleFilter = false
        
        this.mobileSelectedfilters = []
    }

    public get isSubFilterOpen(): boolean {
        return this.showCountryFilter || this.showNorFilter || this.showNocFilter ||
            this.showVumFilter || this.showRoleFilter;
    }

    toggleMobileFilterDialog() {
        if (!this.isSubFilterOpen) {
            this.isMobileFilterOpen = !this.isMobileFilterOpen;
        }

        this.showCountryFilter = false;
        this.showNorFilter = false;
        this.showNocFilter = false;
        this.showVumFilter = false;
        this.showRoleFilter = false;
    }

    hideMobileFilters() {
        this.isMobileFilterOpen = false;
    }

    public mobileSelectedfilters : any[] = []

    public mobileApplyAllFilters(toggleDialog: boolean = true) {
        if(toggleDialog)
            this.toggleMobileFilterDialog();

        this.selectedStatusFilter = [];

        this.mobileSelectedfilters.forEach(x => {
            x.apply();
        })

        //Refresh itemSource irrelevant of number of mobileSelectedFilters. Users may unselect all filters (resulting in no selected filters)
        this.setItemSource();
        this.mobileSelectedfilters = []
    }

    public mobileAddSelectedFilter() {
        if (this.selectedFilter) {
            this.mobileSelectedfilters.push(this.selectedFilter)
            this.selectedFilter = null;
        }
    }


    async activate(){
        let filters : QueryFilter[] = []
        const pathKeywords = `search-keywords-${RightShipQiRouterConstants.RouteNames.CompaniesSearch}`;
        const pathFilters = `search-filters-${RightShipQiRouterConstants.RouteNames.CompaniesSearch}`;

        try {
            this.keywords = await this.cacheClient.get<string>(pathKeywords, CacheLocation.LocalStorage) ;
        }
        catch(err) {
            this.keywords = "";
        }

        try {
            filters = await this.cacheClient.get<QueryFilter[]>(pathFilters, CacheLocation.LocalStorage) ;
        }
        catch(err) {
            filters = [];
        }

        this.cacheClient.remove(pathKeywords, CacheLocation.LocalStorage);
        this.cacheClient.remove(pathFilters, CacheLocation.LocalStorage);

        this.columns = this.getColumns();
        this.itemSource = this.getItemSource(filters);
        this.updateFilters(filters)
    }

    updateFilters(filters: QueryFilter[]) {
        filters.forEach(filter => {
            switch(filter.filterProperty.name) {
                
                case 'countryId': {
                    this.selectedCountries = filter.filterValue
                    break;
                }

                case 'docCount': {
                    if(filter.filterOperator.translatedSymbol == "ge") {
                        this.vumFirstFilter = filter.filterValue
                    }
                    else if(filter.filterOperator.translatedSymbol == "le") {
                        this.vumSecondFilter = filter.filterValue
                    }
                }
            }
        })
    }
    
    refreshActivityCounts() {
    }

    private setItemSource() {
        let currentFilters: QueryFilter[] = [];

        if(this.keywords && this.keywords.length > 0) {
            currentFilters.push(QueryFilter.getQuery("fullName",this.keywords, "contains({0}, '{1}')", DataType.Default, true, false, null, false, true))
        }

        if(this.countryFilterActive) {
            currentFilters.push(QueryFilter.getQuery("countryId", this.selectedCountries,"{0} in ({1})", DataType.Number, true,false,null,false, true));
        }

        if(this.norFilterActive) {
            currentFilters.push(QueryFilter.getQuery("registrationCountryId", this.selectedNors,"{0} in ({1})", DataType.Number, true,false,null,false,true));
        }

        if(this.nocFilterActive) {
            currentFilters.push(QueryFilter.getQuery("controlCountryId", this.selectedNocs,"{0} in ({1})", DataType.Number, true,false,null,false,true));
        }

        if(this.vumFilterActive) {
            const guid = Guid.generateGuid()
            currentFilters.push(QueryFilter.getQuery("docCount",this.vumFirstFilter,"ge", DataType.Number,true,false,guid,true,false))
            currentFilters.push(QueryFilter.getQuery("docCount",this.vumSecondFilter,"le", DataType.Number,true,false,guid,true,false))
        }

        if(this.roleFilterActive) {
            currentFilters = currentFilters.concat(this.roleFilters);
        }
        this.itemSource = this.getItemSource(currentFilters);
    }

    private getColumns() {
        this.columns = [];
        this.columns.push(
            <DataGridColumn>
            {
                dataType: DataType.CustomTemplate,
                value: `<div class="column">
                            <a class="link" href="/company/\${item.companyId}">\${item.fullName}</a>
                            <span if.bind="item.owCode">\${item.owCode}</span>
                        </div>`,
                name: "fullName",
                title: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "Name",
                instancePerRow: true,
                sortOrder: 1,
                columnOrder: -1,
                isHidden: false,
                isSortable: true,
                parameter: {
                    item: null
                }
            },
            <DataGridColumn>
            {
                dataType: DataType.Default,
                name: 'countryName',
                title: "Country",
                instancePerRow: true,
                sortOrder: 2,
                columnOrder: -1,
                isHidden: false,
                isSortable: true,
                tooltipForTitle: "Country of domicile, physical location of the company."
            },
            <DataGridColumn>
            {
                dataType: DataType.Default,
                name: 'registrationCountry',
                title: "Nationality of Registration",
                instancePerRow: true,
                sortOrder: 2,
                columnOrder: -1,
                isHidden: false,
                isSortable: true,
                tooltipForTitle: "Country where the company is legally registered as an entity."
            },
            <DataGridColumn>
            {
                dataType: DataType.Default,
                name: 'controlCountry',
                title: "Nationality of Control",
                instancePerRow: true,
                sortOrder: 2,
                columnOrder: -1,
                isHidden: false,
                isSortable: true,
                tooltipForTitle: "Actual nationality of the company regardless of physical location."
            },
            <DataGridColumn>
            {
                dataType: DataType.Number,
                name: 'docCount',
                title: "Vessels under management",
                instancePerRow: true,
                sortOrder: 2,
                columnOrder: -1,
                isHidden: false,
                isSortable: true,
                tooltipForTitle: "Vessels that this company holds a DOC role"
            }
        );
        return this.columns;
    }

    private getItemSource(filters) {
        this.initialFilters = filters;
        return {
            sourceType: SourceType.ODataUrl,
            source: "odata/CompanySearch",
            columns: this.columns,
            initialSorting: this.initialSorting,
            initialFilters: filters
        };
    }

    searchKeyDown($event) {
        const e: KeyDownEvent = $event.detail;

        if (e.key == "Enter") {
            this.setItemSource();
        }
    }
 
    keywordsChanged() {
        if (!this.keywordProperties) return;

        const toLowerKeywords = this.keywordProperties.map(x => x.toLowerCase());
        const keywordFilters = this.initialFilters.filter(x => toLowerKeywords.indexOf(x.filterProperty.name.toLowerCase()) != -1);

        keywordFilters.forEach(x => {
            const isActive = !this.filters || !this.filters.some(f => f.name == x.filterProperty.name && !f.filterActive);
            x.filterValue = isActive || (x.filterValue == "" && x.filterValue == this.keywords)
                ? this.keywords
                : null;
        });
    }
    
    public determineActivationStrategy() {
        return activationStrategy.replace;
    }
}